export default __webpack_public_path__ + "static/media/chatbot_journey.40084178.svg";